import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import PurchaseTemplateForm from '../../components/Purchase/purchaseTemplateForm';
import { fetchVendors, fetchVendorDetail, resetCurrentVendor } from '../../actions/vendors_actions';
import { fetchProductsByVendor, fetchProductInfo, fetchSimplifiedProducts } from '../../actions/products_actions';
import { fetchPaymentTerms } from '../../actions/paymentTerms_actions';
import { fetchWarehouses } from '../../actions/warehouses_actions';
import { fetchPurchaseTemplateDetail, editPurchaseTemplate, createPurchaseTemplate } from '../../actions/purchaseTemplates_actions';
import { setPriceValues } from '../../actions/purchaseOrders_actions';

let purchaseTemplateForm = reduxForm({
    form: 'purchaseTemplateForm',
})(PurchaseTemplateForm);

const selector = formValueSelector('purchaseTemplateForm')

function mapStateToProps(state) {
    const productInformation = selector(state, 'ProductInformation');

    const templateNameValue = selector(state, 'Name');
    const productsValue = selector(state, 'Purchase_Template_Line');
    const vendorsValue = selector(state, 'Vendor_id');
    const vendorContactValue = selector(state, 'VendorContact');
    const priceTypeValue = selector(state, 'ConvertItemPrice');
    const miscCostValue = selector(state, 'MiscCost');
    const handlingCostValue= selector(state, 'HandlingCost');
    const shippingCostValue = selector(state, 'ShippingCost');
    const allProducts = selector(state, 'AllProducts');
    const allProdQuantity = selector(state, 'AllProd_Quantity');
    const allProdFOBUnitPrice = selector(state, 'AllProd_FOBUnitPrice');
    const allProdEstSalePrice = selector(state, 'AllProd_EstSalePrice');
    return {
        productInformation: productInformation,
        templateNameValue: templateNameValue,
        productsValue: productsValue,
        vendorsValue: vendorsValue,
        vendorContactValue: vendorContactValue,
        priceTypeValue: priceTypeValue,
        miscCostValue: miscCostValue,
        shippingCostValue,
        handlingCostValue,
        allProducts,
        allProdQuantity,
        allProdFOBUnitPrice,
        allProdEstSalePrice,

        currentPurchaseTemplateDetail: state.purchaseTemplates.currentPurchaseTemplateDetail,
        currentPurchaseTemplate: state.purchaseTemplates.currentPurchaseTemplate,
        detailIsLoading: state.purchaseTemplates.detailIsLoading,
        detailError: state.purchaseTemplates.detailError,
        initialValues: state.purchaseTemplates.currentPurchaseTemplateDetail,

        currentPurchaseProduct: state.purchaseTemplates.currentPurchaseProduct,

        isEditing: state.purchaseTemplates.purchaseTemplateIsEditing,
        editError: state.purchaseTemplates.purchaseTemplateEditError,
        isCreating: state.purchaseTemplates.purchaseTemplateIsCreating,
        createError: state.purchaseTemplates.purchaseTemplateCreateError,

        products: state.products.allByVendor,
        productIsLoading: state.products.isLoading,
        productError: state.products.error,
        productInfo: state.products.productInfo,
        productInfoIsLoading: state.products.productInfoIsLoading,
        productInfoError: state.products.productInfoError,
        vendors: state.vendors.all,
        vendorIsLoading: state.vendors.isLoading,
        vendorError: state.vendors.error,
        currentVendorDetail: state.vendors.currentVendorDetail,
        vendorDetailIsLoading: state.vendors.detailIsLoading,
        vendorDetailError: state.vendors.detailError,
        paymentTerms: state.paymentTerms.all,
        paymentTermsIsLoading: state.paymentTerms.isLoading,
        paymentTermsError: state.paymentTerms.error,
        warehouses: state.warehouses.all,
        warehouseIsLoading: state.warehouses.isLoading,
        warehouseError: state.warehouses.error,
        userPermissions: state.auth.userPermissions,

        simplifiedProducts: state.products.simplifiedProducts,
        simplifiedProductsIsLoading: state.products.simplifiedProductsIsLoading,
        simplifiedProductsError: state.products.simplifiedProductsError,
    }
}

export default connect(mapStateToProps, {
    fetchVendors, fetchProductsByVendor, fetchProductInfo, fetchPaymentTerms,
    fetchVendorDetail, resetCurrentVendor, fetchPurchaseTemplateDetail,
    editPurchaseTemplate, createPurchaseTemplate, fetchWarehouses,
    fetchSimplifiedProducts, setPriceValues
})(purchaseTemplateForm)



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchaseTemplateForm.jsx